// range-helper.ts
import { html } from "lit";
var isDefined = (value) => value !== void 0 && value !== null;
var getMongoRangeFilter = ({
  min,
  max,
  fieldName,
  convertToComparableValue = (value) => value
}) => {
  const gte = isDefined(min) && {
    [fieldName]: {
      $gte: convertToComparableValue(min)
    }
  };
  const lte = isDefined(max) && {
    [fieldName]: {
      $lte: convertToComparableValue(max)
    }
  };
  if (gte && lte)
    return { $and: [gte, lte] };
  if (gte && !lte)
    return gte;
  if (lte && !gte)
    return lte;
  return null;
};
var renderRangePreview = ({
  min,
  max,
  convertToDisplayValue = (value) => value,
  greaterString = "Gr\xF6\xDFer-gleich",
  lesserString = "Kleiner-gleich",
  betweenString = ["Zwischen", "und"]
}) => {
  const minDef = isDefined(min);
  const maxDef = isDefined(max);
  return minDef && maxDef ? html` ${betweenString[0]} ${convertToDisplayValue(min)} ${betweenString[1]} ${convertToDisplayValue(max)} ` : minDef && !maxDef ? html` ${greaterString} ${convertToDisplayValue(min)} ` : !minDef && maxDef ? html` ${lesserString} ${convertToDisplayValue(max)} ` : null;
};
export {
  getMongoRangeFilter,
  renderRangePreview
};
